<script setup lang="ts">
import type { LineChartData } from '../index.vue';
import type { ScaleBand } from 'd3';

defineProps<{
  areas: LineChartData['areas'];
  xScale: ScaleBand<string>;
}>();
</script>
<template>
  <div
    v-for="area in areas"
    :key="area.startDate"
    class="absolute top-0 bottom-0 border-1 rounded p-2 duration-300 transition-all"
    :class="{ 'border-dashed': area.dashed }"
    :style="{
      left: `${(xScale(area.startDate) ?? 0) + xScale.bandwidth() / 2}%`,
      width: `${(xScale(area.endDate) ?? 0) - (xScale(area.startDate) ?? 0) + xScale.bandwidth() / 2}%`,
      backgroundColor: area.color,
      borderColor: area.borderColor,
    }"
  >
    <p class="text-xs" :style="{ color: area.borderColor }">{{ area.label }}</p>
  </div>
</template>
